import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { getLegislativeBodiesConfig } from 'src/app/pages/petitionGamma/details/shared/api';

export async function isUserEligibleForLegislativeBodies(
	utilityContext: UtilityContext,
	{
		hasShowLegislativeBodiesParam,
	}: {
		hasShowLegislativeBodiesParam: boolean;
	},
): Promise<boolean> {
	if (hasShowLegislativeBodiesParam) return true;

	const legislativeBodiesEnabled = await getLegislativeBodiesConfig(utilityContext);
	return legislativeBodiesEnabled;
}
